(function () {
  'use strict';

  /* @ngdoc object
   * @description
   *
   */
  angular
    .module('vcutils', [
      'ui.router',
      'vcutils.config',
      'vcutils.doctor',
      'vcutils.heartbeat',
      'vcutils.listeditor',
      'vcutils.map',
      'vcutils.rlog',
      'vcutils.sprhelp',
      'vcutils.sv',
      'vcutils.vcfields',
      'vcutils.printhelper',
      'vcutils.vcshare',
      'vcutils.zipcode'
    ]);
}());
